"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyFieldIsFilledWithException = exports.anyFieldIsFilled = exports.allFieldsAreFilled = exports.asNonEmptyString = exports.parseOptionalIntNanSafe = exports.parseOptionalInt = exports.parseIntNanSafe = exports.mapNotNullablePair = exports.mapNotNullable1 = exports.map = exports.undefinedIf = exports.isBlankString = exports.isNotEmptyString = exports.isEmptyString = exports.hasValue = exports.isEmpty = exports.toOptionalType = exports.toNullUnionType = void 0;
const toNullUnionType = (value) => (value === undefined ? null : value);
exports.toNullUnionType = toNullUnionType;
const toOptionalType = (value) => (value === null ? undefined : value);
exports.toOptionalType = toOptionalType;
const isEmpty = (value) => value === null || value === undefined;
exports.isEmpty = isEmpty;
const hasValue = (value) => !(0, exports.isEmpty)(value);
exports.hasValue = hasValue;
const isEmptyString = (value) => value === null || value === undefined || (typeof value === 'string' && value.length === 0);
exports.isEmptyString = isEmptyString;
const isNotEmptyString = (value) => !(0, exports.isEmptyString)(value);
exports.isNotEmptyString = isNotEmptyString;
const isBlankString = (v) => v === undefined || v === null || v.trim().length === 0;
exports.isBlankString = isBlankString;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const nonEmptyPredicate = (emptyStrAsNone) => emptyStrAsNone ? exports.isNotEmptyString : exports.hasValue;
const undefinedIf = (predicate) => (v) => predicate(v) ? undefined : v;
exports.undefinedIf = undefinedIf;
const map = (f) => (v) => (0, exports.hasValue)(v) ? f(v) : undefined;
exports.map = map;
/*
 * @deprecated Use `map` instead
 */
exports.mapNotNullable1 = exports.map;
// TODO: Find better algebra
const mapNotNullablePair = (f) => (a, b) => (0, exports.isEmpty)(a) || (0, exports.isEmpty)(b) ? undefined : f(a, b);
exports.mapNotNullablePair = mapNotNullablePair;
// tslint:disable-next-line:radix
const parseIntNanSafe = (value) => (0, exports.undefinedIf)(isNaN)(parseInt(value));
exports.parseIntNanSafe = parseIntNanSafe;
const parseOptionalInt = (value) => (0, exports.toOptionalType)((0, exports.map)(parseInt)(value));
exports.parseOptionalInt = parseOptionalInt;
const parseOptionalIntNanSafe = (value) => (0, exports.toOptionalType)((0, exports.map)(exports.parseIntNanSafe)(value));
exports.parseOptionalIntNanSafe = parseOptionalIntNanSafe;
exports.asNonEmptyString = (0, exports.undefinedIf)((v) => v === undefined || v.length === 0);
const allFieldsAreFilled = (emptyStrAsNone) => 
// eslint-disable-next-line @typescript-eslint/ban-types
(object) => Object.keys(object).length === 0 ? false : Object.values(object).every(nonEmptyPredicate(emptyStrAsNone));
exports.allFieldsAreFilled = allFieldsAreFilled;
const anyFieldIsFilled = (emptyStrAsNone) => 
// eslint-disable-next-line @typescript-eslint/ban-types
(object) => {
    return Object.values(object).some(nonEmptyPredicate(emptyStrAsNone));
};
exports.anyFieldIsFilled = anyFieldIsFilled;
const anyFieldIsFilledWithException = (emptyStrAsNone) => (object, exceptionPredicate) => Object.entries(object).some(([fieldName, item]) => !exceptionPredicate(fieldName) && nonEmptyPredicate(emptyStrAsNone)(item));
exports.anyFieldIsFilledWithException = anyFieldIsFilledWithException;
